import React from 'react';

const SvgAutomaticPaymentsBg = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 47" {...props}>
    <path d="M0 11.667v3.889h60v-3.89H0zM32.958 32.32h-3.375l-3.626 7.173h3.46l3.541-7.173zm7.5 0h-3.375l-3.458 7.173h3.458l3.375-7.173zm14 0h-10l-3.334 7.173h9.833l3.502-7.173zM52.959 0c1.9.028 3.71.83 5.013 2.226A7.537 7.537 0 0160 7.476V39.19a7.539 7.539 0 01-2.028 5.251 7.002 7.002 0 01-5.014 2.225H7.124a7.002 7.002 0 01-5.014-2.225 7.539 7.539 0 01-2.028-5.25V7.474C-.018 3.467 3.11.13 7.083 0h45.874z" />
  </svg>
);

export default SvgAutomaticPaymentsBg;
